module.exports = __webpack_public_path__ + "static/media/ic_moisture_50.40762e97.svg";